<template>
  <div id="download-form">
    <h3>Lataa passi ja tule tutustumaan!</h3>
    <div class="inputs">
      <div class="input">
        <vs-input border v-model="name" label-placeholder="Etunimi">
          <template #icon>
            <i class="bx bx-user"></i>
          </template>
          <template #message-warn v-if="invalidName">
            Nimessä voi olla vain aakkosia
          </template>
        </vs-input>
      </div>

      <div class="input">
        <vs-input
          border
          type="email"
          v-model="email"
          label-placeholder="Sähköposti"
          style="width:100%"
        >
          <template #icon>
            <i class="bx bx-envelope"></i>
          </template>
          <template #message-danger v-if="missingEmail">
            Sähköpostiosoite on pakollinen
          </template>
          <template #message-warn v-if="invalidEmail">
            Sähköpostiosoite väärässä muodossa
          </template>
        </vs-input>
      </div>

      <vs-button @click="submit"
        ><i class="bx bx-cloud-download"></i> Lataa passi
      </vs-button>
    </div>
    <div class="instructions">
      <transition name="slider" appear>
        <div class="step step-1">
          <svg
            class="arrow-step-1"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 61.6 65.9"
            style="enable-background:new 0 0 61.6 65.9;"
            xml:space="preserve"
          >
            <path
              id="Path_11"
              class="st0"
              d="M33.6,28.2L37.7,5l-27.5,9l18.6-0.2c0,0-19.4,6.4-5,51.5"
            />
          </svg>
          <span>1. Syötä tietosi</span>
        </div>
      </transition>

      <transition name="slidel" appear>
        <div class="step step-2">
          <span>2. Paina lataa passi</span>
          <svg
            class="arrow-step-2"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 89.6 51.2"
            style="enable-background:new 0 0 89.6 51.2;"
            xml:space="preserve"
          >
            <path
              id="Path_6"
              class="st0"
              d="M0.3,25.9c0,0,86,63.5,74-13l-8.5,16.5l5-28.5l18.5,14.5"
            />
          </svg>
        </div>
      </transition>

      <transition name="sliderr" appear>
        <div class="step step-3">
          <span>3. Tule kokeilemaan!</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "EmailForm",
  data: () => ({
    name: "",
    email: "",
    missingEmail: false,
    invalidEmail: false,
    invalidName: false,
    regEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    regName: /^[A-Za-zÀ-ÖØ-öø-ÿ]*$/
  }),
  computed: mapGetters(["getSelectedClub"]),
  methods: {
    ...mapActions(["saveMauticData"]),
    submit() {
      const loading = this.$vs.loading({
        type: "rectangle"
      });
      if (this.name) {
        if (!this.validateName()) this.invalidName = true;
        else this.invalidName = false;
      }

      if (!this.email) this.missingEmail = true;
      else this.missingEmail = false;

      if (!this.missingEmail && !this.validateEmail()) this.invalidEmail = true;
      else this.invalidEmail = false;

      if (this.missingEmail || this.invalidEmail || this.invalidName)
        loading.close();
      else {
        const contactData = {
          email: this.email,
          tag: this.getSelectedClub.mautic.tag,
          segmentID: this.getSelectedClub.mautic.segmentID,
          campaignID: this.getSelectedClub.mautic.campaignID
        };
        if (this.name) contactData.firstName = this.name;
        axios
          .post(
            "https://www.lataapassi.fi/api/v1/mautic/kuntokruunu/subscribe",
            contactData
          )
          .then(res => {
            this.saveMauticData(res.data);
            this.$router.push({ name: "Kiitos" });
            this.$ga.event(
              "Forms",
              "Submit",
              "Lataa passi " + this.getSelectedClub.location
            );
            window.fbq.push("trackCustom", "lataa-passi", {
              kuntokeskus: this.getSelectedClub.location
            });
          })
          .catch(error => {
            if (error.response.status === 409)
              this.$router.push({
                name: "Virhe",
                query: {
                  email: error.response.data.email
                }
              });
          })
          .finally(() => loading.close());
      }
    },
    validateEmail() {
      return this.regEmail.test(this.email);
    },
    validateName() {
      return this.regName.test(this.name);
    }
  }
};
</script>

<style scoped>
h3 {
  margin-bottom: 1.9em;
  font-size: 16px;
}
.input >>> .vs-input {
  width: 100% !important;
}
.vs-button {
  margin-left: auto;
}
.vs-button i {
  padding-right: 5px;
}
.instructions {
  max-width: 85%;
  margin: 0 auto;
  font-weight: bold;
}
.step {
  padding-bottom: 0.5em;
  text-align: left;
}
.step-1 {
  position: relative;
}
.arrow-step-1 {
  width: 55px;
  height: auto;
  position: absolute;
  top: -68px;
  left: -21px;
}
.step-2 {
  text-align: right;
  padding-bottom: 0;
}
.step-2 span {
  padding-right: 0.5em;
  position: relative;
  top: -25px;
}
.arrow-step-2 {
  width: 90px;
  height: auto;
}
.st0 {
  fill: none;
  stroke: rgb(var(--vs-text));
}
.step-3 {
  margin-top: -6px;
}
.slider-enter-active {
  transition: all 1s ease-out 3s;
}
.slidel-enter-active {
  transition: all 1s ease-out 5s;
}
.sliderr-enter-active {
  transition: all 1s ease-out 7s;
}
.slider-enter,
.slidel-enter,
.sliderr-enter {
  opacity: 0;
}
.slider-enter,
.sliderr-enter {
  transform: translateX(-30%);
}
.slidel-enter {
  transform: translateX(30%);
}
@media (min-width: 1025px) {
  #download-form {
    width: 59%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  #download-form > div {
    width: 100%;
  }
  .instructions {
    max-width: 78%;
  }
}
</style>
